<template>
    <div>
        <multiselect
                class="form-control"
                v-model="value"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a tag"
                :options="options"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
                @input="emitChange"
        />
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    export default {
        name: "multiselectInput",
        components: {
            Multiselect
        },
        props:{
            value: Array,
            options: Array
        },
        data () {
            return {
            }
        },
        methods: {
            addTag (tag) {
                this.$emit('change', [...this.value, tag]);
            },
            emitChange(value) {
                this.$emit('change', value);
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>
